import {useEffect} from 'react';
import {useSelector} from 'react-redux';
import {useLocation} from 'react-router-dom';

import appConfig from '../configs/appConfig';
import themeService from '../services/themeService';
import {selectIsAppInitialized, selectOverriddenTheme, selectTheme} from '../state/selectors/global';
import {selectTopRenderedPopup} from '../state/selectors/modal';
import {setOverriddenTheme} from '../state/slice/global';
import {dispatch} from '../state/store';

const useThemeOverride = () => {
    const {pathname} = useLocation();
    const defaultTheme = useSelector(selectTheme);
    const currentModal = useSelector(selectTopRenderedPopup);
    const overriddenTheme = useSelector(selectOverriddenTheme);
    const isAppInitialized = useSelector(selectIsAppInitialized);

    const overrideTheme = (theme) => {
        if (theme === overriddenTheme) return;

        dispatch(setOverriddenTheme(theme));
    };

    useEffect(() => {
        if (!isAppInitialized) return;

        themeService.applyTheme(overriddenTheme || defaultTheme, false);
    }, [overriddenTheme, isAppInitialized]);

    useEffect(() => {
        const storiesType = currentModal?.modalProps?.storiesType;

        if (storiesType) {
            const {theme} = appConfig.getStoriesConfig(storiesType) || {};

            if (theme) {
                overrideTheme(theme);
                return;
            }
        }
        if (currentModal) {
            const {theme} = appConfig.getModalsConfig(currentModal?.modalType) || {};

            overrideTheme(theme);
            return;
        }
        const {theme} = appConfig.getPageConfig(pathname) || {};

        overrideTheme(theme);
    }, [pathname, currentModal]);
};

export default useThemeOverride;
